
















import Vue from 'vue'
import activeTableTree from '@/components/Ui/ActiveTableTree/ActiveTableTree.vue'
import tableTreeConfig from '@/activeTableTrees/wiki/list'
import User from '@/models/Users/User'
import {USER_ROLE_WIKI, PROJ_PFX} from '@/constants'
import {setSessStoreItem, getSessStoreItem} from '@/services/sessionStorageTransfer'
import WikiNode from '@/models/wiki/wikiNode'
const sessStorExpandedState = `${PROJ_PFX}wikiTree_expanded_state`
export default Vue.extend({
  name: 'wikiTree',
  components: {
    activeTableTree
  },
  data () {
    return {
      tableTreeConfig,
      tree: [],
      defaultExpandedKeys: [] as string[],
      expandedKeys: [] as string[]
    }
  },
  methods: {
    async getWikiTree (): Promise<void> {
      try {
        let list = await this.$store.dispatch('wiki/getNodesTree')
        this.tree = list;
        console.log('LOG: getWikiTree -> list', list)
      } catch (error) {
        console.error('LOG: getWikiTree -> error', error)
      }
    },
    onActionsError (error: any): void {
      console.log('TableTree Actions Error', error)
      if (error.getMessage() === 'children nodes exist' || error.getMessage() === 'children pages exist') {
        this.$message({
          // @ts-ignore
          message: this.$t('wiki.node_has_children'),
          type: 'warning'
        });
      }
    },
    onActionsSuccess (item: any): void {
      let message = this.$t('labels.unknown_action');
      if (item && item.row.isNode) {
        // @ts-ignore
        message = this.$t('wiki.node_deleted')
      } else {
        // @ts-ignore
        message = this.$t('wiki.single_node_deleted')
      }
      this.$message({
        // @ts-ignore
        message,
        type: 'success'
      });
    },
    onNodeExpand (event: WikiNode) {
      const key = event.id
      if (this.expandedKeys.indexOf(key) < 0) {
        this.expandedKeys.push(key)
      }
      this.saveExpandedKeys()
    },
    onNodeCollapse (event: WikiNode) {
      const index = this.expandedKeys.indexOf(event.id)
      if (index >= 0) {
        this.expandedKeys.splice(index, 1);
      }
      this.saveExpandedKeys()
    },
    saveExpandedKeys () {
      setSessStoreItem(sessStorExpandedState, this.expandedKeys)
    },
    getExpandedKeys () {
      return getSessStoreItem(sessStorExpandedState)
    },
    setDefaultExpandedKeys () {
      const state = this.getExpandedKeys()
      if (state) {
        this.defaultExpandedKeys = state
      }
    }
  },
  computed: {
    user (): User | false {
      return this.$store.state.user.user
    },
    hasActionsPerm (): boolean {
      if (this.user) {
        return this.$store.state.user.user.checkRole(USER_ROLE_WIKI)
      } else {
        return false;
      }
    }
  },
  async mounted () {
    this.setDefaultExpandedKeys()
    await this.getWikiTree()
  }
})
